const _ACTION_PREFIX = 'frontend/locale';
export const SET = `${_ACTION_PREFIX}/SET_LOCALE`;
export const SET_COOKIE_SUCCESS = `${_ACTION_PREFIX}/SET_COOKIE_SUCCESS`;
export const MOMENT_UPDATED = `${_ACTION_PREFIX}/MOMENT_UPDATED`;

export const setLocale = (language, region) => ({
  type: SET,
  payload: { language, region },
});

export const cookieSuccess = () => ({
  type: SET_COOKIE_SUCCESS,
});

export const momentUpdated = () => ({
  type: MOMENT_UPDATED,
});
